import React from 'react';
import EmailVerify from "./EmailVerify";
import SignupForm from "./SignupForm";
import {useSelector} from "react-redux";
import EmailVerified from "./EmailVerified";
import ChooseSubscription from "./ChooseSubscription"
import BillingDetails from "./BillingDetails/BillingDetails";
import PaymentComplete from "./PaymentComplete";

const useCode = process.env.REACT_APP_USE_CODE_4 === 'true';


export default function Signup() {

    //redux state
    const { loginStep } = useSelector((state) => state.login)

    return (
        <>
            { loginStep === 1 && <SignupForm /> }

            { (loginStep === 2 && (useCode === true)) && <EmailVerify />}
            { (loginStep === 3 && (useCode === true)) && <EmailVerified />}

            { loginStep === 2 && <ChooseSubscription />}
            { loginStep === 3 && <BillingDetails />}
            { loginStep === 4 && <PaymentComplete />}
        </>

    );
}


